import { existsSync } from "node:fs";
import { dirname, join, resolve } from "node:path";
import { fileURLToPath } from "node:url";

/**
 * Find the package root directory by looking for package.json
 * Works both in bundled (dist/) and source (src/) contexts
 */
export function findPackageRoot(currentFileUrl: string): string {
  const currentFile = fileURLToPath(currentFileUrl);
  let currentDir = dirname(currentFile);

  // Walk up the directory tree until we find package.json
  while (currentDir !== dirname(currentDir)) {
    const packageJsonPath = join(currentDir, "package.json");
    if (existsSync(packageJsonPath)) {
      return currentDir;
    }
    currentDir = dirname(currentDir);
  }

  // Fallback: assume we're in dist/ and go up one level
  return resolve(dirname(fileURLToPath(currentFileUrl)), "..");
}

/**
 * Get the SVG directory path from the package root
 */
export function getSvgDir(currentFileUrl: string): string {
  const packageRoot = findPackageRoot(currentFileUrl);
  return join(packageRoot, "assets/pixelarticons/svg");
}
